module.exports = __webpack_public_path__ + "img/secret_step_4.fcde2f15.svg";